
// AJAX PROGRESS BAR
(function () {
    
    function newGuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    var ajaxQueue = {};

    $(document).ajaxSend(function (event, jqXHR, ajaxOptions) {
        var id = newGuid();


        if (ajaxOptions.xhrFields === undefined)
            ajaxOptions.xhrFields = {};

        ajaxOptions.xhrFields['ag_id'] = id;

        var timer = setTimeout(function () {
            AjaxHelpers.AgBlockUi();
        }, 3000);

        var queueData = { id: id, timer: timer };
        ajaxQueue[id] = queueData;
        console.log(ajaxOptions);

    });

    $(document).ajaxComplete(function (event, jqXHR, ajaxOptions) {
        var id = ajaxOptions.xhrFields['ag_id'];
        ajaxQueue[id].timer = clearTimeout(ajaxQueue[id].timer);
        delete ajaxQueue[id];

        if (Object.keys(ajaxQueue).length === 0) {
            $.unblockUI();
        }
    });

    // STORE REQUEST URL IN REQUEST
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        jqXHR.originalUrl = originalOptions.url;
    });

    // HANDLE AJAX ERRORS
    $(document).ajaxError(function (event, jqXhr, ajaxSettings, thrownError) {
        if (!AjaxHelpers.HandleExpiredSession(jqXhr) && thrownError.length > 0 && $.agito.isMobileApp == false)
            alert(thrownError);
    });

    $(document).ajaxSuccess(function (event, request, settings) {
        AjaxHelpers.HandleExpiredSession(request);
    });
})();

function AjaxHelpers() { }

$.AgBlockUi = function () { AjaxHelpers.AgBlockUi() }

AjaxHelpers.AgBlockUi = function () {
    $.blockUI({
        baseZ: 2000,
        message: '<div style="height:125px;width:125px;"><div class="cssload-spin-box"></div></div>',
        css: { width: '20%', left: '40%' }
    });
}

AjaxHelpers.GetUrlParam = function (name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp(name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

AjaxHelpers.NewGuid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

AjaxHelpers.HandleExpiredSession = function (request) {
    if (request.getResponseHeader('REQUIRES_AUTH') === '1' && $.agito.isMobileApp == false) {
        //do not open multiple dialogs
        if ($('#modalReauthenticate').length > 0) {
            return true;
        }

        var messageText = Agitavit.Utilities.localizeResourceKey("Account_Requires_Reauthentication");
        var headerText = Agitavit.Utilities.localizeResourceKey("Account_Requires_Reauthentication_Header");
        var buttonText = Agitavit.Utilities.localizeResourceKey("Account_Requires_Reauthentication_Button");

        $('<div class="modal modal-stack ui-draggable" tabindex="-1" role="dialog" data-bs-backdrop="static" id="modalReauthenticate" style="display: block; z-index: 1050;background-color: rgba(0, 0, 0, 0.5);">'
            + '<div style="height: 80px; min-width:300px; top: 40%;width:800px;pading-left:50%;" class="modal-dialog">'
            + '<div class="modal-content ui-resizable ui-draggable" style="display: block;">'
            + '<div class="modal-header ui-draggable-handle">' + '<h4 class="modal-title">' + headerText + '</h4>' + '</div>'
            + '<div class="modal-body">' + messageText + '</div>' 
            + '<div class="modal-footer"><button id="btnReauthenticate" onclick="AjaxHelpers.ReauthenticateUser();" class="btn btn-primary btn-submit" type="submit">' + buttonText + '</button></div>'
            + '</div>'
            + '</div>'
            + '</div>')
            .appendTo('body');

        return true;
    }
    return false;
}


AjaxHelpers.ReauthenticateUser = function () {
    if ($.agito.isMobileApp == true) {
        window.location = window.location;
    } else {
        var reauthenticationSuccessUrl = $.agito.baseUrl + "Account/ReauthenticationSuccess";
        var loginPopup = window.open(reauthenticationSuccessUrl, '', 'width=600,height=700');

        if (loginPopup != null) {
            $('#btnReauthenticate').prop('disabled', true);
            var interv = setInterval(function () {
                if (loginPopup.location.pathname == reauthenticationSuccessUrl) {
                    $('#modalReauthenticate').remove();
                    loginPopup.close();
                    clearInterval(interv);
                    interv = false;
                } else if (loginPopup.closed) {
                    $('#btnReauthenticate').prop('disabled', false);
                    clearInterval(interv);
                    interv = false;
                }
            }, 1000);
        } else {
            window.location = window.location;
        }
    }
}